// ...existing imports and component definition...

const Header: React.FC = () => {
  return (
    <header
      style={{
        background: "linear-gradient(135deg, #1E3C73 0%, #2a5298 100%)",
        padding: "1rem 2rem",
        boxShadow: "0 4px 24px rgba(30, 60, 115, 0.15)",
        position: "sticky",
        top: 0,
        zIndex: 100,
      }}
    >
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          flexWrap: "wrap",
          gap: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
            cursor: "pointer",
          }}
          onClick={() => {
            window.dispatchEvent(new CustomEvent('navigate', { detail: { page: 'home' } }));
          }}
        >
          <img
            src="/favicon.png"
            alt="JLC"
            style={{
              width: "48px",
              height: "48px",
              objectFit: "contain",
              filter: "drop-shadow(0 2px 8px rgba(0, 0, 0, 0.2))",
            }}
          />
          <div>
            <h1
              style={{
                fontSize: "1.5rem",
                fontWeight: 700,
                color: "white",
                margin: 0,
                letterSpacing: "-0.02em",
              }}
            >
              JLCTalents
            </h1>
            <p
              style={{
                fontSize: "0.875rem",
                color: "rgba(255, 255, 255, 0.8)",
                margin: 0,
              }}
            >
              Toutes les compétences JLC, en un seul endroit.
            </p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
